export const fmtBRL = (v: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v);

export const fmtNumber = (v: number) => new Intl.NumberFormat("pt-BR").format(v);

export const fmtPct = (v: number, digits = 1) =>
  `${v.toFixed(digits).replace(".", ",")}%`;

/**
 * "DD/MM" a partir de uma data ISO. Aceita tanto `"2026-06-30"` quanto o ISO
 * completo `"2026-06-30T00:00:00.000Z"` que um campo `Date` produz ao ser
 * serializado em JSON — sem o corte no "T", o dia saía como "30T00:00:00.000Z".
 *
 * A leitura é feita na própria string, e não via `new Date()`, para não deslocar
 * o dia por fuso: uma data-only vira meia-noite UTC e, a oeste de Greenwich,
 * `getDate()` devolveria o dia anterior.
 */
export const fmtDateShort = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}`;
};

export const fmtDateTime = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

/**
 * Tira o travessão (—) do meio das frases: "vs. setembro de 2026 — mesmo período"
 * vira "vs. setembro de 2026, mesmo período". Um "—" sozinho (campo sem valor)
 * fica como está.
 */
export const tidyText = (s: string) =>
  s.includes("—") && s !== "—"
    ? s.replace(/\s+—\s+/g, ", ").replace(/^—\s+/, "").replace(/\s+—$/, "")
    : s;
